import { render, staticRenderFns } from "./shopping-cart-products-list.vue?vue&type=template&id=72874c6c&scoped=true&"
import script from "./shopping-cart-products-list.vue?vue&type=script&lang=js&"
export * from "./shopping-cart-products-list.vue?vue&type=script&lang=js&"
import style0 from "./shopping-cart-products-list.vue?vue&type=style&index=0&id=72874c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72874c6c",
  null
  
)

export default component.exports